import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // import router
import './assets/styles.css' // import styles
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css' // import Font Awesome
import * as bootstrap from 'bootstrap'

// Make Bootstrap available globally
window.bootstrap = bootstrap

createApp(App).use(router).mount('#app')
